import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiFileChartOutline } from "@mdi/js";
import CardShell from "./CardShell";
import { formatDateTimeLong } from "app/containers/Jobs/utils/dateFormat";
import { compiledReportUrl } from "utils/helperFunctions/compiledReportUrl";

const ReportCard = ({ job, onDeferred }) => {
  const report = job.report || {};
  const viewUrl = report.compiled_report_id
    ? compiledReportUrl(report.compiled_report_id)
    : null;

  return (
    <CardShell
      icon={
        <Icon path={mdiFileChartOutline} size={0.7} className="jd-card-icon" />
      }
      title="Report"
      className="jd-card--half jd-report-card"
    >
      {report.compiled ? (
        <div className="jd-report-body">
          <div className="jd-report-summary">
            <div className="jd-value-strong">Compiled</div>
            <div className="jd-subtle">
              {formatDateTimeLong(report.compiled_at)}
            </div>
          </div>
          <div className="jd-report-cover">
            {report.thumbnail_url ? (
              <img src={report.thumbnail_url} alt="Inspection report cover" />
            ) : (
              <Icon
                path={mdiFileChartOutline}
                size={1.2}
                className="jd-report-cover-placeholder"
              />
            )}
            <Button
              variant="primary"
              size="sm"
              className="jd-report-cover-btn"
              onClick={() =>
                viewUrl
                  ? window.open(viewUrl, "_blank", "noopener,noreferrer")
                  : onDeferred("View report")
              }
            >
              View Report
            </Button>
          </div>
        </div>
      ) : (
        <div className="jd-muted-heading">Not compiled yet</div>
      )}
    </CardShell>
  );
};

export default ReportCard;
